var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back_homepage_arrow"},[_c('nuxt-link',{attrs:{"to":_vm.backButtonMobile.to}},[_vm._v("\n        "+_vm._s(_vm.backButtonMobile.text)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }